<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 19.5H0.5V10C0.5 4.75329 4.75329 0.5 10 0.5C15.2467 0.5 19.5 4.75329 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5Z" stroke="currentColor"/>
        <path d="M7.5 8C7.5 7.72422 7.56466 7.55115 7.6903 7.29637C7.81594 7.04158 8.00009 6.81008 8.23223 6.61508C8.46438 6.42007 8.73998 6.26539 9.04329 6.15985C9.34661 6.05432 9.6717 6 10 6C10.3283 6 10.6534 6.05432 10.9567 6.15985C11.26 6.26539 11.5356 6.42007 11.7678 6.61508C11.9999 6.81008 12.1841 7.04158 12.3097 7.29636C12.4353 7.55115 12.5 7.72422 12.5 8C12.5 9.9 10 10 10 11.6V12" stroke="currentColor" stroke-width="1.5"/>
        <path d="M9 15C9 14.4477 9.44772 14 10 14V14C10.5523 14 11 14.4477 11 15V15C11 15.5523 10.5523 16 10 16V16C9.44772 16 9 15.5523 9 15V15Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGQuestion',
};
</script>

<style scoped lang="scss">

</style>
